export const SEARCH_START = 'search/start';
export const SEARCH_END = 'search/end';
export const SUGGEST_START = 'suggest/start';
export const SUGGEST_END = 'suggest/end';
